import _sfc_main from "./Header.vue2.js";
/* empty css            */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const Header = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-9f112db1"]]);
export {
  Header as default
};
//# sourceMappingURL=Header.vue.js.map
